var _style, _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.2mm",
    height: "21.2mm",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * {\n      stroke-width: 0px;\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-3421",
    x: 8.1,
    y: 8.1,
    width: 43.8,
    height: 43.8,
    rx: 10,
    ry: 10,
    transform: "translate(-12.4 30) rotate(-45)",
    strokeWidth: 0,
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-3521",
    x: 10,
    y: 11.8,
    width: 40,
    height: 40,
    rx: 10,
    ry: 10,
    transform: "translate(-13.7 30.5) rotate(-45)",
    strokeWidth: 0,
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5,21.3h-2.3l-1.4-1.4c-.5-.5-1.2-.5-1.7,0l-1.4,1.4h-20.4c-1.1,0-2,.9-2,2s.9,2,2,2h20.4l1.4,1.4c.5.5,1.2.5,1.7,0l1.4-1.4h2.3c1.1,0,2-.9,2-2s-.9-2-2-2Z",
    strokeWidth: 0,
    fill: "#82368c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5,29.7h-8.6l-1.4-1.4c-.5-.5-1.2-.5-1.7,0l-1.4,1.4h-14.2c-1.1,0-2,.9-2,2s.9,2,2,2h14.2l1.4,1.4c.5.5,1.2.5,1.7,0l1.4-1.4h8.6c1.1,0,2-.9,2-2s-.9-2-2-2Z",
    strokeWidth: 0,
    fill: "#82368c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5,38.1h-4.9l-1.4-1.4c-.5-.5-1.2-.5-1.7,0l-1.4,1.4h-17.9c-1.1,0-2,.9-2,2s.9,2,2,2h17.9l1.4,1.4c.5.5,1.2.5,1.7,0l1.4-1.4h4.9c1.1,0,2-.9,2-2s-.9-2-2-2Z",
    strokeWidth: 0,
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDownIcon);
export default __webpack_public_path__ + "static/media/FilterDownIcon.f21bf55837db4126343dbd27e8582a82.svg";
export { ForwardRef as ReactComponent };